import { useCallback, useEffect } from 'react';

type TArgs = Parameters<typeof useCallback>;
type TCallback = TArgs[0];
type TDeps = TArgs[1];

/**
 * Debounces an effect until after the dependencies settle
 * *** Make sure your dependencies are correct! ***
 * @param delay Milliseconds to debounce the effect
 * @param effect Imperative function that can return a cleanup function
 * @param deps Effect will only activate if the values in the list change.
 */

export const useDebounceEffect = (delay: number, cb: TCallback, deps: TDeps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fn = useCallback(cb, deps);
  useEffect(() => {
    const timeout = setTimeout(fn, delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [fn, delay]);
};
